import { useState, useEffect } from "react";
import "./ImageSlider.css";
import base from "./deal_completion_rate_based_on_promotion_type_-20250424T173943.png";
import roi from "./funkey_creators_roi.png";
import comp from "./deal_completion_rate_fy24_-20250424T173220.png";
import newc from "./new_client_deals_fy_24_-20250424T173655.png"

const images = [base, roi, comp,newc];

const ImageSlider = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  useEffect(() => {
    const interval = setInterval(nextSlide, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="slider-container">
      <h2 className="slider-heading">Our Statistics</h2>
      <div className="slider-wrapper">
        <img src={images[currentIndex]} alt="Slide" className="slider-image" />
        <button onClick={prevSlide} className="slider-button left">&#10094;</button>
        <button onClick={nextSlide} className="slider-button right">&#10095;</button>
      </div>
    </div>
  );
};

export default ImageSlider;
